import { Stack, Text } from '@solvhealth/jigsaw-v1';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ALMA_CATEGORY } from '~/components/AccountGetsMarried/constants/alma';
import {
  consumerServiceCategories,
  ConsumerServiceCategory,
} from '~/components/AccountGetsMarried/constants/ConsumerServices/consumerServiceCategories';
import { analyticsTrackEvent } from '~/core/analytics';
import {
  ALMA_CARD_SEEN,
  ALMA_ENTRYPOINT_CLICKED,
  ALMA_ENTRYPOINT_DRAWER,
  CONSUMER_SERVICES_ENTRYPOINT_ACCOUNT_HOME,
  CONSUMER_SERVICE_CATEGORY_CARD_TOUCHED,
  DRAWER_TYPE_MENTAL_HEALTH,
  NAV_TILE_CLICKED,
} from '~/core/analytics/events';
import history from '~/core/history';
import { RemixRoutes } from '~/core/remix';
import { isUserProfileAMinor } from '~/core/util/userProfile';
import { useObserveVisibility } from '~/hooks/useObserveVisibility';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';
import { useTrackNavTile } from '../hooks/useTrackNavTile';
import { Details, Icon, Root, SubTitle, Title } from '../styles';

type Props = {};
const MentalHealth = ({}: Props) => {
  const category = consumerServiceCategories.find(
    (cat) => cat.slug === ALMA_CATEGORY
  ) as ConsumerServiceCategory;

  const onClick = () => {
    history.push(`/services/${category.slug}`);
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_MENTAL_HEALTH,
    });
    analyticsTrackEvent(CONSUMER_SERVICE_CATEGORY_CARD_TOUCHED, {
      category: category.slug,
      position: category.sortOrder,
      entrypoint: CONSUMER_SERVICES_ENTRYPOINT_ACCOUNT_HOME,
      variant: 'drawer',
    });

    analyticsTrackEvent(ALMA_ENTRYPOINT_CLICKED, {
      entrypoint: ALMA_ENTRYPOINT_DRAWER,
    });
  };

  useTrackNavTile('mental-health');

  const ref = useRef<HTMLDivElement>();

  useObserveVisibility(ref, () => {
    analyticsTrackEvent(ALMA_CARD_SEEN, {
      entrypoint: ALMA_ENTRYPOINT_DRAWER,
    });
  });

  return (
    // We cast `ref` to `any` here as Styled Components makes `ref` typing tricky.
    <Root onClick={onClick} ref={ref as any}>
      <Icon alt="Mental Health" src="/images/account/tiles/mental-health-3-23.svg" />
      <Details>
        <Stack alignItems="center" row space={1}>
          <Title>Mental health</Title>
          <Text
            sx={{
              bg: 'crunchberry-xlight',
              textTransform: 'uppercase',
              fontWeight: 'bold',
              px: 0.5,
              borderRadius: 'sm',
            }}
            textColor="crunchberry-dark"
            variant="caption"
          >
            New
          </Text>
        </Stack>
        <SubTitle>Find therapists who take insurance</SubTitle>
      </Details>
    </Root>
  );
};

export default MentalHealth;
